import * as Styled from './ViewEmailCampaigns.styles';

import { CampaignInfo } from './components/CampaignInfo';
import { ROUTES } from 'features/routes';
import { UploadCohort } from './components/UploadCohort';
import { DesktopOnlyMessage } from '../components/DesktopOnlyMessage';
import { getEmailCampaigns } from '../services';
import { useHistory } from 'react-router-dom';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useRef } from 'react';
import { useResponsiveScreen } from 'hooks/useWindowSize';
import { useTranslation } from 'react-i18next';
import { PunchupButton } from 'features/common/components/Punchup/primitives/buttons/PunchupButton';

export const ViewEmailCampaigns = ({ isPunchup = false }: { isPunchup?: boolean }) => {
	const { push } = useHistory();
	const { t } = useTranslation();
	const isLargeScreen = useResponsiveScreen();
	const numOfPages = useRef(0);

	const { data } = useInfiniteQuery({
		queryKey: ['email-campaigns'],
		queryFn: (pageParam) => getEmailCampaigns(pageParam, numOfPages),
		getNextPageParam: (_, pages) => pages.length < numOfPages.current && pages.length + 1,
	});
	return (
		<Styled.MainContainer isPunchup={isPunchup}>
			{isLargeScreen ? (
				<Styled.CenterContent isPunchup={isPunchup}>
					<Styled.ContentTitle isPunchup={isPunchup}>{t('marketing-viewEmailCampaigns-title')}</Styled.ContentTitle>
					<Styled.ButtonContainer>
						{isPunchup ? (
							<PunchupButton
								variant="primary"
								text={t('marketing-viewEmailCampaingns-create')}
								onClick={() => push(ROUTES.CREATE_CAMPAIGN_PATH)}
							/>
						) : (
							<Styled.CustomButton
								type="button"
								text={t('marketing-viewEmailCampaingns-create')}
								onClick={() => push(ROUTES.CREATE_CAMPAIGN_PATH)}
							/>
						)}
						<UploadCohort isPunchup={isPunchup} />
					</Styled.ButtonContainer>
					{data?.pages.map((page) =>
						page.map((campaignData) => (
							<CampaignInfo key={campaignData?.id} campaignData={campaignData} isPunchup={isPunchup} />
						))
					)}
					{/* {hasNextPage && (
						<FlexContainer justifyContent="center">
							<Styled.LoadMoreButton handleClick={() => fetchNextPage()} isDisabled={!hasNextPage} />
						</FlexContainer>
					)} */}
				</Styled.CenterContent>
			) : (
				<DesktopOnlyMessage isPunchup={isPunchup} />
			)}
		</Styled.MainContainer>
	);
};
